<template>
    <BDropdown
        :noCaret="true"
        :noFade="true"
        :noFlip="true"
        class="js-waves-off"
    >
        <template #button-content>
            <div :title="user.contact_name" class="header-icon d-flex align-items-center justify-content-center ml-2 js-waves-off">
                <img src="/templates/imc_tenders/images/icons/user_profile.png" class="profile-image rounded-circle" alt="Contact Person">
            </div>
        </template>
        
        <BDropdownForm formClass="no-padding">
            <div class="">
                <div class="dropdown-header bg-trans-gradient d-flex flex-row py-4 rounded-top">
                    <div class="d-flex flex-row align-items-center mt-1 mb-1 color-white">
                        <div class="info-card-text">
                            <div class="fs-lg text-truncate text-truncate-lg">
                                {{user.contact_name}}
                            </div>
                            <span class="text-truncate text-truncate-md opacity-80">
                                {{user.email}}
                            </span>
                        </div>
                    </div>
                </div>
                
                <div class="dropdown-divider m-0"></div>
                <a href="/profile" class="dropdown-item" >
                    <span >Мій кабінет</span>
                </a>
                
                <div class="dropdown-divider m-0"></div>
                <a href="#" class="dropdown-item" data-action="app-fullscreen">
                        <span >Повноекраний режим</span>
                    <i class="float-right text-muted fw-n">F11</i>
                </a>
                <a href="#" class="dropdown-item" data-action="app-print">
                    <span data-i18n="drpdwn.print">Друкувати</span>
                    <i class="float-right text-muted fw-n">Ctrl + P</i>
                </a>
                <div class="dropdown-divider m-0"></div>
                
                <a class="dropdown-item fw-500 pt-3 pb-3" @click.stop.prevent="logout">
                    <span data-i18n="drpdwn.page-logout">Вихід</span>
                </a>
            </div>
        </BDropdownForm>
        
    </BDropdown>
</template>


<script>

import {BDropdown} from "bootstrap-vue-next";
import {BDropdownForm} from "bootstrap-vue-next";
import {mapGetters} from "vuex";
export default {
    name: "userProfile",
    components: {
        BDropdown,
        BDropdownForm
    },
    computed: {
        ...mapGetters({
            'user': "user/getUser",
        }),
    },
    
    methods : {
        async logout() {
            IMC_CORE.showloading()
            await axios.post('/internal/api/logout').then(({data}) => {
                window.location.reload();
            }).catch(err => {
                IMC_CORE.hideloading()
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        },
    },
}
</script>


<style scoped>

</style>